module.exports = __webpack_public_path__ + "static/dododo8m-49fbf373853f4aa4548e0f9564d407d5.jpg";